module.exports = __webpack_public_path__ + "media/images/logo-a812c0b9294b8dcc557efce7889cfabd.svg";